import React, { useCallback, useEffect, useState } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ReactComponent as WishmakerLogo } from '../../assets/img/svg/wishmaker-logo-big.svg';
import { BodyText, HeadingThree } from '../../components/typography';
import Button from '../../components/ui/button';
import InlineLoading from '../../components/ui/inline-loading';
import { sendFinishRegistrationEmail } from '../../redux/action';
import dlt from '../../utils/default-lang';
import FinishRegistrationSC from './finish-registration.styled';

const FinishRegistration = ({ sendFinishRegistrationEmail, match, history }) => {
  const [sentAt, setSentAt] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sentAgain, setSentAgain] = useState(false);

  const wmNumber = match.params.wmNumber;

  const sendEmail = useCallback(
    (sendAgain = false) => {
      setIsLoading(true);
      sendFinishRegistrationEmail({
        wmNumber: wmNumber,
        sendAgain: sendAgain,
        onSuccess: (response) => {
          setSentAt(response.sent_at);
          setIsLoading(false);
          if (sendAgain) {
            setSentAgain(true);
          }
        },
        onError: () => {
          setIsLoading(false);
        },
      });
    },
    [sendFinishRegistrationEmail, wmNumber]
  );

  useEffect(() => {
    sendEmail();
  }, [sendEmail, wmNumber]);

  return (
    <FinishRegistrationSC>
      <div className="logo-wrap">
        <WishmakerLogo />
      </div>
      <div className="form-wrap">
        <div className="row">
          <div className="headline-block">
            <HeadingThree>
              <FormattedMessage
                id="finish_registration_title"
                defaultMessage={dlt['finish_registration_title']}
              />
            </HeadingThree>
            <div style={{ marginBottom: '12px' }}>
              <BodyText className="bolder black-transparent">
                <FormattedHTMLMessage
                  id="finish_registration_text"
                  defaultMessage={dlt['finish_registration_text']}
                  values={{ wmNumber }}
                />
              </BodyText>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <Link
                to={{
                  pathname: `/personal-information-processing/${wmNumber}`,
                  state: history.location.state,
                }}
              >
                {`${process.env.REACT_APP_BASE_URL}/personal-information-processing/${wmNumber}`}
              </Link>
            </div>
            <div
              style={{
                width: '100%',
                height: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: sentAt ? 'flex-start' : 'center',
                flexDirection: 'column',
              }}
            >
              {sentAt ? (
                <>
                  <BodyText className="bolder black-transparent" style={{ marginBottom: '12px' }}>
                    <FormattedMessage
                      id="finish_registration_email_sent_at"
                      defaultMessage={dlt['finish_registration_email_sent_at']}
                    />{' '}
                    <span style={{ fontWeight: 'bold' }}>
                      <Moment format="DD.MM.YYYY">{sentAt}</Moment> o{' '}
                      <Moment format="HH:mm:ss">{sentAt}</Moment>
                    </span>
                    .
                  </BodyText>
                  {sentAgain ? (
                    <span>
                      <FormattedMessage
                        id="finish_registration_email_sent_again"
                        defaultMessage={dlt['finish_registration_email_sent_again']}
                      />
                    </span>
                  ) : isLoading ? (
                    <div style={{ marginTop: '10px' }}>
                      <InlineLoading className="inline-loader" />
                    </div>
                  ) : (
                    <Button
                      type="OUTLINED"
                      onClick={() => sendEmail(true)}
                      className="no-text-transform"
                    >
                      <FormattedMessage
                        id="finish_registration_email_sent_again_button"
                        defaultMessage={dlt['finish_registration_email_sent_again_button']}
                      />
                    </Button>
                  )}
                </>
              ) : (
                <InlineLoading className="inline-loader" />
              )}
            </div>
          </div>
        </div>
      </div>
    </FinishRegistrationSC>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      sendFinishRegistrationEmail: sendFinishRegistrationEmail,
    },
    dispatch
  );
};

export default withRouter(connect(null, mapDispatchToProps)(FinishRegistration));
